/**
 * Requires Authentication Guard
 * Verifica que el usuario esté autenticado.
 * Espera a que Firebase Auth restaure la sesión antes de decidir.
 */

import type { RouteLocationNormalized } from 'vue-router'
import type { RouteGuard, GuardResult } from './RouteGuard'
import { useAuthStore } from '@/stores/auth'
import { auth, authReady } from '@/services/firebase/config'

export class RequiresAuthGuard implements RouteGuard {
  name = 'requiresAuth'

  async canActivate(to: RouteLocationNormalized): Promise<GuardResult> {
    // Wait for Firebase Auth to restore session from IndexedDB before deciding
    await authReady

    const authStore = useAuthStore()

    // Ensure auth store reflects Firebase Auth state.
    // Handles race condition: authReady may resolve before App.vue registers
    // its onAuthStateChanged listener, leaving the store out of sync.
    if (auth.currentUser && !authStore.isAuthenticated) {
      authStore.setUser(auth.currentUser)
    } else if (!auth.currentUser && authStore.isAuthenticated) {
      authStore.setUser(null)
    }

    // Verificar si la ruta requiere autenticación
    const requiresAuth = to.meta.requiresAuth !== false

    if (requiresAuth && !authStore.isAuthenticated) {
      // Usuario no autenticado intentando acceder a ruta protegida
      return '/login'
    }

    if (!requiresAuth && authStore.isAuthenticated) {
      // Usuario autenticado intentando acceder a rutas públicas (login, register)
      return '/dashboard'
    }

    return true
  }
}
